import {useCallback} from 'react';
import {useStore} from 'react-redux';

import {getAvailableProducts} from 'src/openapi/admin/apis/ProductsApi';
import {useAppDispatch, useAppSelector} from 'src/store/hooks';

import {
    productsFailed, productsLoading, selectProducts, selectProductsError, selectProductsStatus,
} from './services/dictionary-slice';

import type {AppState} from 'src/store/typedef';

export const useProducts = () => {
    const store = useStore<AppState>();
    const dispatch = useAppDispatch();
    const products = useAppSelector(selectProducts);
    const status = useAppSelector(selectProductsStatus);
    const error = useAppSelector(selectProductsError);
    const loadProducts = useCallback(async () => {
        const currentStatus = selectProductsStatus(store.getState());
        if (currentStatus === 'loading' || currentStatus === 'succeeded') {
            return;
        }
        store.dispatch(productsLoading());
        try {
            await dispatch(getAvailableProducts());
        } catch {
            store.dispatch(productsFailed({message: 'Failed to load products'}));
        }
    }, [dispatch, store]);
    return {products, status, error, loadProducts};
};
